import { Folder } from "@/types/folder"

export const folderMixin = {
	methods: {
		// Returns the number of levels of a provided folder path
		getFolderLevelCountFromPath (folderPath: string): number {
			if (!folderPath.includes("\\")) {
				return 0
			}

			// Return count - 1 as we shouldn't count the root folder
			return folderPath.split("\\").length - 1
		},
		// Returns the folder name for the lowest sub folder in a provided folder path
		getFolderNameFromPath (folderPath: string) {
			if (!folderPath.includes("\\")) {
				// Path doesn't include any sub folders
				return folderPath
			}

			// Return the last name in the folder path
			return folderPath.split("\\").slice(-1).toString()
		},
		// Returns the full path back to the root for a provided folder
		getPathToRootFolder (folder: Folder, folderList: Folder[], includeCurrentFolder: boolean = false): string {
			// Check if parent folder exists
			if (!folder.parentFolderId || folder.parentFolderId == null) {
				if (includeCurrentFolder) {
					return folder.title
				} else {
					return ""
				}
			}

			// Create list of direct sub folders of provided folder ID
			let folderPathToRoot: string = ""
			let parentFolderExists: boolean = true
			let parentFolder: Folder | undefined
			let parentFolderId: string | undefined = folder.parentFolderId

			while (parentFolderExists) {
				if (!parentFolderId) {
					parentFolderExists = false
					break
				}

				// Get the parent folder
				parentFolder = folderList.find((f: Folder) => f.id === parentFolderId)

				if (!parentFolder) {
					parentFolderExists = false
					break
				}

				// Append to the root folder path
				if (folderPathToRoot.length > 0) {
					folderPathToRoot = parentFolder.title + "\\" + folderPathToRoot
				} else {
					folderPathToRoot = parentFolder.title
				}

				parentFolderId = parentFolder.parentFolderId
			}

			if (includeCurrentFolder) {
				// Add the current folder to the path
				if (folderPathToRoot.length > 0) {
					folderPathToRoot = folderPathToRoot + "\\" + folder.title
				} else {
					folderPathToRoot = folder.title
				}
			}

			return folderPathToRoot
		},
		// Returns the folder for the loewest sub folder for a provided folder path
		getFolderFromPath (folderTitle: string, folderList: Folder[]): Folder {
			let folderToReturn: any = {}
			const folderName = this.getFolderNameFromPath(folderTitle)

			// Filter the list of folders to those that match the provided folder name
			folderList.filter(f => f.title === folderName).map(folder => {
				// It is possible to have folders with the same name under different folder structures, so get the folder that matches the full path
				if (this.getPathToRootFolder(folder, folderList, true) === folderTitle) {
					folderToReturn = folder
				}
			})

			return folderToReturn
		},
		// Returns a list of folder paths to the root for a provided list of folders
		getListOfFolderPathsToRootFolder (folderList: Folder[], includeCurrentFolder: boolean = false) : string[] {
			let folderPathList: string[] = []

			folderList.forEach(folder => {
				folderPathList.push(this.getPathToRootFolder(folder, folderList, includeCurrentFolder))
			})

			return folderPathList
		}
	}
}
